import {formatDate} from "@ui-seeker/utils";


export default function lastSeenColumn() {
	return {
		name: 'lastSeen',
		label: 'Last Seen on Retailer',
		options: {
			setCellProps: () => ({ sx: { textAlign: 'center' } }),
			customBodyRowRender: value => !value ? 'N/A' :  formatDate(value, { isString: true })
		}
	}
}